module.exports = __webpack_public_path__ + "static/autoMessage.a9dcb66f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/autoMessage.svg
// module id = ./src/assets/svgs/autoMessage.svg
// module chunks = 72138227098318